const keyFor = (userId?: string | null) =>
  userId ? `appUILang:${userId}` : 'appUILang';
export const getStoredLanguage = (userId?: string | null) => {
  try {
    return window.localStorage.getItem(keyFor(userId)) || '';
  } catch {
    return '';
  }
};
export const setStoredLanguage = (language: string, userId?: string | null) => {
  try {
    window.localStorage.setItem(keyFor(userId), language);
  } catch {
    /* Account preference remains authoritative when storage is unavailable. */
  }
};
export const getBrowserLanguages = (): readonly string[] => {
  if (typeof navigator === 'undefined') return ['en'];
  return navigator.languages?.length
    ? navigator.languages
    : [navigator.language];
};
export const subscribeBrowserLanguage = (callback: () => void) => {
  window.addEventListener('languagechange', callback);
  return () => window.removeEventListener('languagechange', callback);
};
export const subscribeLanguageSession = (callback: () => void) => {
  window.addEventListener('storage', callback);
  window.addEventListener('user-summary-updated', callback);
  window.addEventListener('auth-session-updated', callback);
  return () => {
    window.removeEventListener('storage', callback);
    window.removeEventListener('user-summary-updated', callback);
    window.removeEventListener('auth-session-updated', callback);
  };
};
